<template>
  <div>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <p slot="title">健康信息</p>
      <Form
        style="margin: 30px 20px"
        :model="formItem"
        :label-width="150"
        label-position="left"
      >
        <div class="formRow">
          <div class="formCol" v-if="showSelfData.disablity == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.disablity : enNameMap.disablity"
            >
              <Checkbox
                :disabled="disableSelfData.disablity"
                v-model="formItem.disablity"
              ></Checkbox>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.eDisablity == '1'">
            <FormItem
              :label="
                lang == 'zh' ? chNameMap.eDisablity : enNameMap.eDisablity
              "
            >
              <Input
                :disabled="disableSelfData.eDisablity"
                v-model="formItem.eDisablity"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.cDisablity == '1'">
            <FormItem
              :label="
                lang == 'zh' ? chNameMap.cDisablity : enNameMap.cDisablity
              "
            >
              <Input
                :disabled="disableSelfData.cDisablity"
                v-model="formItem.cDisablity"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.height == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.height : enNameMap.height"
            >
              <Input
                :disabled="disableSelfData.height"
                v-model="formItem.height"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.weight == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.weight : enNameMap.weight"
            >
              <Input
                :disabled="disableSelfData.weight"
                v-model="formItem.weight"
              />
            </FormItem>
          </div>
          <div
            class="formCol"
            v-if="showSelfData.leftEye == '1' || showSelfData.righteye == '1'"
          >
            <FormItem
              :label="
                lang == 'zh'
                  ? chNameMap.leftEyeOrRightEye
                  : enNameMap.leftEyeOrRightEye
              "
            >
              <Input
                :disabled="disableSelfData.leftEye"
                v-model="formItem.lefteye"
                style="width:48%;"
              />
              <Input
                :disabled="disableSelfData.righteye"
                v-model="formItem.righteye"
                style="width:48%;margin-left:1%"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.eyeColor == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.eyeColor : enNameMap.eyeColor"
            >
              <Input
                :disabled="disableSelfData.eyeColor"
                v-model="formItem.eyecolor"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.clothSize == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.clothSize : enNameMap.clothSize"
            >
              <Input
                :disabled="disableSelfData.clothSize"
                v-model="formItem.clothsize"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.shoeSize == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.shoeSize : enNameMap.shoeSize"
            >
              <Input
                :disabled="disableSelfData.shoeSize"
                v-model="formItem.shoesize"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.smoker == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.smoker : enNameMap.smoker"
            >
              <Checkbox
                :disabled="disableSelfData.smoker"
                v-model="formItem.smoker"
              ></Checkbox>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.bloodType == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.bloodType : enNameMap.bloodType"
            >
              <Input
                :disabled="disableSelfData.bloodType"
                v-model="formItem.bloodtype"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.rhType == '1'">
            <FormItem
              :label="lang == 'zh' ? chNameMap.rhType : enNameMap.rhType"
            >
              <Input
                :disabled="disableSelfData.rhType"
                v-model="formItem.rhtype"
              />
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.lastDonateDate == '1'">
            <FormItem
              :label="
                lang == 'zh'
                  ? chNameMap.lastDonateDate
                  : enNameMap.lastDonateDate
              "
            >
              <DatePicker
                :disabled="disableSelfData.lastDonateDate"
                type="date"
                v-model="formItem.lastdonatedate"
              ></DatePicker>
            </FormItem>
          </div>
          <div class="formCol" v-if="showSelfData.nextDonateDate == '1'">
            <FormItem
              :label="
                lang == 'zh'
                  ? chNameMap.nextDonateDate
                  : enNameMap.nextDonateDate
              "
            >
              <DatePicker
                :disabled="disableSelfData.nextDonateDate"
                type="date"
                v-model="formItem.nextdonatedate"
              ></DatePicker>
            </FormItem>
          </div>
          <div class="formCol"></div>
        </div>
      </Form>
    </Card>
    <div class="formRow">
      <Card
        class="cardStyle"
        :style="{
          backgroundImage: `url(${getWaterMarkStatus})`
        }"
      >
        <p slot="title">慢性病</p>
        <Form
          style="margin: 30px 20px"
          :model="formItem"
          :label-width="150"
          label-position="left"
        >
          <div>
            <div class="cardChild" v-if="showSelfData.eChronic1 == '1'">
              <FormItem
                :label="
                  lang == 'zh' ? chNameMap.eChronic1 : enNameMap.eChronic1
                "
              >
                <Input
                  :disabled="disableSelfData.eChronic1"
                  v-model="formItem.eChronic1"
                />
              </FormItem>
            </div>
            <div class="cardChild" v-if="showSelfData.cChronic1 == '1'">
              <FormItem
                :label="
                  lang == 'zh' ? chNameMap.cChronic1 : enNameMap.cChronic1
                "
              >
                <Input
                  :disabled="disableSelfData.cChronic1"
                  v-model="formItem.cChronic1"
                />
              </FormItem>
            </div>
            <div class="cardChild" v-if="showSelfData.eChronic2 == '1'">
              <FormItem
                :label="
                  lang == 'zh' ? chNameMap.eChronic2 : enNameMap.eChronic2
                "
              >
                <Input
                  :disabled="disableSelfData.eChronic2"
                  v-model="formItem.eChronic2"
                />
              </FormItem>
            </div>
            <div class="cardChild" v-if="showSelfData.cChronic2 == '1'">
              <FormItem
                :label="
                  lang == 'zh' ? chNameMap.cChronic2 : enNameMap.cChronic2
                "
              >
                <Input
                  :disabled="disableSelfData.cChronic2"
                  v-model="formItem.cChronic2"
                />
              </FormItem>
            </div>
            <div class="cardChild" v-if="showSelfData.eChronic3 == '1'">
              <FormItem
                :label="
                  lang == 'zh' ? chNameMap.eChronic3 : enNameMap.eChronic3
                "
              >
                <Input
                  :disabled="disableSelfData.eChronic3"
                  v-model="formItem.eChronic3"
                />
              </FormItem>
            </div>
            <div class="cardChild" v-if="showSelfData.cChronic3 == '1'">
              <FormItem
                :label="
                  lang == 'zh' ? chNameMap.cChronic3 : enNameMap.cChronic3
                "
              >
                <Input
                  :disabled="disableSelfData.cChronic3"
                  v-model="formItem.cChronic3"
                />
              </FormItem>
            </div>
          </div>
        </Form>
      </Card>
      <Card
        class="cardStyle"
        :style="{
          backgroundImage: `url(${getWaterMarkStatus})`
        }"
      >
        <p slot="title">过敏症</p>
        <Form
          style="margin: 30px 20px"
          :model="formItem"
          :label-width="150"
          label-position="left"
        >
          <div>
            <div class="cardChild" v-if="showSelfData.eAllergy1 == '1'">
              <FormItem
                :label="
                  lang == 'zh' ? chNameMap.eAllergy1 : enNameMap.eAllergy1
                "
              >
                <Input
                  :disabled="disableSelfData.eAllergy1"
                  v-model="formItem.eAllergy1"
                />
              </FormItem>
            </div>
            <div class="cardChild" v-if="showSelfData.cAllergy1 == '1'">
              <FormItem
                :label="
                  lang == 'zh' ? chNameMap.cAllergy1 : enNameMap.cAllergy1
                "
              >
                <Input
                  :disabled="disableSelfData.cAllergy1"
                  v-model="formItem.cAllergy1"
                />
              </FormItem>
            </div>
            <div class="cardChild" v-if="showSelfData.eAllergy2 == '1'">
              <FormItem
                :label="
                  lang == 'zh' ? chNameMap.eAllergy2 : enNameMap.eAllergy2
                "
              >
                <Input
                  :disabled="disableSelfData.eAllergy2"
                  v-model="formItem.eAllergy2"
                />
              </FormItem>
            </div>
            <div class="cardChild" v-if="showSelfData.cAllergy2 == '1'">
              <FormItem
                :label="
                  lang == 'zh' ? chNameMap.cAllergy2 : enNameMap.cAllergy2
                "
              >
                <Input
                  :disabled="disableSelfData.cAllergy2"
                  v-model="formItem.cAllergy2"
                />
              </FormItem>
            </div>
            <div class="cardChild" v-if="showSelfData.eAllergy3 == '1'">
              <FormItem
                :label="
                  lang == 'zh' ? chNameMap.eAllergy3 : enNameMap.eAllergy3
                "
              >
                <Input
                  :disabled="disableSelfData.eAllergy3"
                  v-model="formItem.eAllergy3"
                />
              </FormItem>
            </div>
            <div class="cardChild" v-if="showSelfData.cAllergy3 == '1'">
              <FormItem
                :label="
                  lang == 'zh' ? chNameMap.cAllergy3 : enNameMap.cAllergy3
                "
              >
                <Input
                  :disabled="disableSelfData.cAllergy3"
                  v-model="formItem.cAllergy3"
                />
              </FormItem>
            </div>
          </div>
        </Form>
      </Card>
    </div>
    <div class="bottomBtn">
      <Button type="primary" :disabled="isClick"  @click="saveData()">保存</Button>
      <Button v-if="plan" @click="returnPage()" style="margin-left: 15px"
        >返回</Button
      >
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import axios from "axios";
import watermark from "@/util/watermark";
import DateUtil from "@/util/DateUtil";

export default {
  data() {
    return {
      date: new DateUtil(),
      oldFormItem: {},
      formItem: {},
      workStatus: [
        {
          value: "现职",
          label: "现职"
        }
      ],
      smoker: null,
      disablity: null,
      disableSelfData: {},
      showSelfData: {},
      chNameMap: {},
      enNameMap: {},
      id: null,
      plan: null,
      loading: false,
      userId: ""
    };
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    getWaterMarkStatus() {
      return this.$store.getters.getWaterMarkStatus == 1
        ? watermark.addWaterMark()
        : "";
    },
    isClick() {
      return JSON.stringify(this.getNewValue()) == "{}" 
    }
  },
  created() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.userId = userInfo.serialnumber;
  },
  methods: {
    getData(id, plan) {
      this.plan = plan ? plan : "";
      this.id = id;
      this.getTableData();
    },
    getTableData() {
      let obj = {
        sheetId: this.id,
        serialnumber: this.plan ? this.plan : this.userId,
        bePersonal: this.plan ? "0" : "1"
      };
      this.loading = true;
      axios
        .post("/HealthInformation/searchUserHealthInformation", obj)
        .then(res => {
          this.loading = false;
          if (res) {
            this.formItem = res.data.length > 0 ? res.data[0] : {};
            for (var item in this.formItem) {
               if (typeof(this.formItem[item]) == 'string'  && this.formItem[item].indexOf('1900-01-01') != -1) {
                this.formItem[item] = ''
               }
            }
            this.oldFormItem = JSON.parse(JSON.stringify(this.formItem));
            this.formItem.smoker = !!+this.formItem.smoker;
            this.formItem.disablity = !!+this.formItem.disablity;
            this.showSelfData = res.showSelfData;
            this.chNameMap = res.chNameMap;
            this.enNameMap = res.enNameMap;
            this.disableSelfData = res.disableSelfData;
            this.disablePopin(this.disableSelfData);
          }
        });
    },
    disablePopin(disableSelfData) {
      for (var key in disableSelfData) {
        if (disableSelfData[key] == 0) {
          disableSelfData[key] = true;
        } else {
          disableSelfData[key] = false;
        }
      }
    },
    getNewValue() {
      let obj = {};
      for (var item in this.formItem) {
        if (this.oldFormItem[item] != this.formItem[item]) {
          if (this.formItem[item] instanceof Date) {
              this.formItem[item] = this.date.dateVal(this.formItem[item], "YYYY-MM-DD")
          }
          if (typeof this.oldFormItem[item] == "object") {
            if (
              this.oldFormItem[item].join("") != this.formItem[item].join("")
            ) {
              obj[item] = this.formItem[item];
            }
          } else {
            obj[item] = this.formItem[item];
          }
        }
      }
      return obj;
    },
    saveData() {
     this.formItem.smoker = this.formItem.smoker == true ? 1 : 0
     this.formItem.disablity = this.formItem.disablity == true ? 1 : 0
      let newFormItem = this.getNewValue();
      
      this.$Modal.confirm({
        title: this.$notice("sureSave"),
        content: "",
        onOk: () => {
          let obj = {
            serialnumber: this.plan ? this.plan : this.userId,
            ...newFormItem
          };
          axios
            .post("/HealthInformation/rollBackUserHealthInformation", obj)
            .then(res => {
              if (res) {
                this.$Message.info(res);
                this.getTableData();
              }
            });
        },
        onCancel: () => {}
      });
    },
    returnPage() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.formRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.formCol {
  width: calc((100% - 210px) / 3);
  float: left;
}
.cardStyle {
  width: 50%;
  margin-top: 20px;
}
.cardChild {
  width: 60%;
  float: left;
}
@media screen and (max-width: 1300px) and (min-width: 800px) {
  .formCol {
    width: calc((100% - 40px) / 2);
  }
}
@media screen and (max-width: 800px) {
  .formCol {
    width: 100%;
  }
}
@media screen and (max-width: 950px) and (min-width: 770px) {
  .cardStyle {
    width: 100%;
    margin-top: 20px;
  }
  .cardChild {
    width: 100%;
    float: left;
  }
}
@media screen and (max-width: 770px) {
  .formCol {
    width: 100%;
    margin-right: 0px;
  }
  .cardStyle {
    width: 100%;
    margin-top: 20px;
  }
  .cardChild {
    width: 100%;
    float: left;
  }
}
.bottomBtn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.ivu-date-picker {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/process/MyQuery/components/HealthInformation.vue